import Phaser from 'phaser';
import { BootScene } from '@/scenes/BootScene';
import { KingdomScene } from '@/scenes/KingdomScene';

export function createGameConfig(): Phaser.Types.Core.GameConfig {
  return {
    type: Phaser.AUTO,
    parent: 'game-container',
    backgroundColor: '#0a0a1a',
    scale: {
      mode: Phaser.Scale.RESIZE,
      width: '100%',
      height: '100%',
      autoCenter: Phaser.Scale.CENTER_BOTH,
    },
    scene: [BootScene, KingdomScene],
    render: {
      pixelArt: false,
      antialias: true,
    },
    input: {
      touch: true,
    },
  };
}
